module.exports = __webpack_public_path__ + "img/solar.30260219.png";